import {Title} from "./styled";

export const SectionTitle = ({children}) => {
    return (
        <Title>
            {children}
        </Title>
    )
}